export default __webpack_public_path__ + "static/media/report.183ba2c0.svg";